import { AnswerCardType, QueryIntent } from './constants';

export const getAnswerCardType: (
	isReadingAids: boolean,
	smartAnswersRoute?: QueryIntent,
) => AnswerCardType = (isReadingAids: boolean, smartAnswersRoute?: QueryIntent): AnswerCardType => {
	if (isReadingAids) {
		return AnswerCardType.DEFINITION;
	}

	switch (smartAnswersRoute) {
		case QueryIntent.PERSON:
			return AnswerCardType.PERSON;
		case QueryIntent.TEAM:
			return AnswerCardType.TEAM;
		case QueryIntent.AGENT:
			return AnswerCardType.AGENT;
		case QueryIntent.DATE:
			return AnswerCardType.DATE;
		case QueryIntent.LOCATION:
			return AnswerCardType.LOCATION;
		case QueryIntent.TOPIC:
			return AnswerCardType.TOPIC;
		case QueryIntent.JIRA_NATURAL_LANGUAGE_QUERY:
			return AnswerCardType.JIRA_NATURAL_LANGUAGE_QUERY;
		case QueryIntent.JIRA_ISSUE:
			return AnswerCardType.JIRA_ISSUE;
		case QueryIntent.NAV_CONTENT:
			return AnswerCardType.NAV_CONTENT;
		case QueryIntent.BOOKMARK:
			return AnswerCardType.BOOKMARK_KNOWLEDGE_CARD;
		case QueryIntent.VISUAL:
			return AnswerCardType.VISUAL;
		case QueryIntent.ORG_CHART:
			return AnswerCardType.ORG_CHART;
		case QueryIntent.NAVIGATIONAL:
			return AnswerCardType.NAVIGATIONAL;
		case QueryIntent.NONE:
			return AnswerCardType.NONE;
		case QueryIntent.DEFAULT:
			return AnswerCardType.DEFAULT;
		case QueryIntent.NATURAL_LANGUAGE_QUERY:
		case QueryIntent.KEYWORD_OR_ACRONYM:
		default:
			return AnswerCardType.SAIN;
	}
};
